export default __webpack_public_path__ + "static/media/pan.9ae253a8.png";